// extracted by mini-css-extract-plugin
module.exports = {"introbox":"introbox_introbox__x44ZB"};